// https://stackoverflow.com/a/8852679/19165618

const generateGmailLink = (to: string, subject: string, body: string) => {
  return `https://mail.google.com/mail/?view=cm&fs=1&to=${to}&su=${subject}&body=${body}`;
};

export { generateGmailLink };
